export default __webpack_public_path__ + "static/0-e022517142a7c8413fb4a972c4e68c72.png";